import { render, staticRenderFns } from "./horizontal-ranking-bak.vue?vue&type=template&id=4cb3cc70"
import script from "./horizontal-ranking-bak.vue?vue&type=script&lang=js"
export * from "./horizontal-ranking-bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports